import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SocialLink from '@piconetworks/pkg-social-links';
import styles from './Brand.module.scss.js';

var Brand = function Brand(_ref) {
  var _cx;
  var isPaymentLP = _ref.isPaymentLP,
    showBrandName = _ref.showBrandName,
    showLogo = _ref.showLogo,
    showSocialLinks = _ref.showSocialLinks,
    socialLinks = _ref.socialLinks,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? {} : _ref$values;
  var profile_image_preview = values.profile_image_preview,
    brand_name = values.brand_name;
  var data = socialLinks.data;
  var links = data ? Object.values(data) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (showLogo || showBrandName || showSocialLinks && !!(links !== null && links !== void 0 && links.length)) && /*#__PURE__*/React.createElement("div", {
    className: cx(styles.brandHeader, 'page-contrast-color', (_cx = {}, _cx[styles.whiteBg] = isPaymentLP, _cx)),
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo,
    style: showLogo ? {} : {
      marginTop: '2rem'
    }
  }, showLogo && /*#__PURE__*/React.createElement("div", {
    style: profile_image_preview && {
      backgroundImage: "url('" + profile_image_preview + "')"
    }
  }), showBrandName && /*#__PURE__*/React.createElement("h1", null, brand_name)), showSocialLinks && !!(links !== null && links !== void 0 && links.length) && /*#__PURE__*/React.createElement("div", {
    className: styles.socialLinks
  }, /*#__PURE__*/React.createElement(SocialLink, {
    name: "socialLinks",
    links: links
  }))));
};
Brand.propTypes = {
  dispatch: PropTypes.func,
  isPaymentLP: PropTypes.bool,
  showBrandName: PropTypes.bool,
  showLogo: PropTypes.bool,
  showSocialLinks: PropTypes.bool,
  socialLinks: PropTypes.object,
  values: PropTypes.object
};
var Brand$1 = /*#__PURE__*/React.memo(Brand);

export { Brand$1 as default };
//# sourceMappingURL=index.js.map
